/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/* eslint-disable no-param-reassign */
import { types } from 'mobx-state-tree';
import PublishPlatformOption from './PublishPlatformOption';
import { getDistributionOptions as DistributionConstants } from '../constants/projectStatusAndPlatformConstants';

export default types
  .model('BulkPublishPlatformOptions', {
    bulkPublishPlatformOptions: types.optional(
      types.array(PublishPlatformOption),
      [
        {
          id: DistributionConstants.COL_VIRTUALSCHOOLS_ID,
          label: DistributionConstants.COL_VIRTUALSCHOOLS_LABEL,
          checked: false,
          visible: true
        }
      ]
    ),
    // Needed this property to rerender components
    selectionChangeCount: 0
  })
  .actions(self => ({
    getPublishPlatformOptions() {
      return self.bulkPublishPlatformOptions;
    },
    updateBulkColumnVisibility(id, value) {
      const column = self.bulkPublishPlatformOptions.find(el => el.id === id);
      column.setSelection(value);
    }
  }));
